import { makeStyles, Theme } from '@material-ui/core/styles';
import { orange } from 'styles/abstract/variables';

export const makeBookStyles = makeStyles((theme: Theme) => ({
    chip: {
        margin: '0.5rem 0.5rem 0 0',
    },
    iconWrapper: {
        display: 'flex',
        marginRight: '0.25rem',
    },
    input: {
        padding: '0.625rem 1rem',
        width: '3rem',
    },
    paragraph: {
        fontSize: '0.875rem',
        margin: '0.5rem 0',
    },
    price: {
        fontSize: '1.5rem',
        fontWeight: 600,
        position: 'absolute',
        right: 0,
        top: '-3rem',
    },
}));

export const makeOutlinedInputClasses = makeStyles({
    root: {
        marginRight: '1rem',

        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: orange,
        },
    },
});
